module.exports = __webpack_public_path__ + "img/virtual-reality.f0d8c70c.svg";